import { render } from "./ModalAllegati.vue?vue&type=template&id=62f5d842&scoped=true"
import script from "./ModalAllegati.vue?vue&type=script&lang=js"
export * from "./ModalAllegati.vue?vue&type=script&lang=js"

import "./ModalAllegati.vue?vue&type=style&index=0&id=62f5d842&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f5d842"]])

export default __exports__